/** @jsxImportSource solid-js */

import { customElement, noShadowDOM } from "solid-element";
import { WarningCallout } from "#root/lib/palette/components/callout.solid.js";

customElement("recovery-error-callout", {}, () => {
  noShadowDOM();

  return (
    <WarningCallout title="Your Account is Missing Recovery Information">
      <p>
        This might happen if you created your account before we added account
        recovery, or if there was an error when you tried to create your
        account.
      </p>
      <p>
        <a href="/account-settings">Click here</a> to add this so you can
        recover access to your account in the future;{" "}
        <strong>
          without this, you will not be able to reset your password if you lose
          it
        </strong>
        .
      </p>
    </WarningCallout>
  );
});
